

import Vue from 'vue'

import VueRouter from 'vue-router'
import App from './App'
import Home from './pages/index'
import Global from '../src/global'
import Cs from './pages/cs'
import upload from './pages/upload'
import posters from './pages/posters'
import data from './pages/data'
import VueCropper from "vue-cropper"


import ToastPlugin from 'vux/src/plugins/toast/index.js'

import LoadingPlugin from 'vux/src/plugins/loading/index.js'




Vue.use(VueCropper);
Vue.use(VueRouter);
Vue.use(ToastPlugin);
Vue.use(LoadingPlugin);
Vue.prototype.Global = Global.globalData; 
Vue.prototype.request = Global.request; 
Vue.prototype.requestGet = Global.requestGet; 
Vue.prototype.validations = Global.validations; 
Vue.prototype.local = JSON.parse(localStorage.getItem(Global.globalData.appid)); 

const routes = [{

path: '/',
redirect: "/index",
},
{
path: '/index',
component: Home,
name: "Home",
},
{
path: '/upload',
component: upload,
name: "upload",
},
{
path: '/cs',
component: Cs,
name: "cs",
},
{
path: '/posters',
component: posters,
name: "posters",
},
{
path: '/data',
component: data,
name: "data",
}
]

const router = new VueRouter({
routes
})



Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js